import { singleLevelProtectedAxiosInstance, protectedAxiosInstance, zeroParamProtectedAxiosInstance } from 'helpers/api-calls';

const removeUserAvatar = (userId) => {
  const user =  { "profile_id": null };
  return singleLevelProtectedAxiosInstance.put(`/api/customer/user_role/users/${userId}`, {user}, {
    params: { 'response[put_return_resource]': true }
  });
}

const updateUser = (userId, user) => {
  return zeroParamProtectedAxiosInstance.put( `/api/customer/user_role/users/${userId}`, { user }, 
    { params: { 'response[put_return_resource]': true } }
  );
};

const updateUserPrivilege = (userPrivilegeId, user_privilege) => {
    return protectedAxiosInstance.put( `/api/customer/admin_role/user_privileges/${userPrivilegeId}`, { user_privilege }, 
        { params: { 'response[put_return_resource]': true } }
    );
};

const deleteUserByPrivilegeId = (userPrivilegeId) => {
    return protectedAxiosInstance.delete( `/api/customer/user_role/user_privileges/${userPrivilegeId}`, 
        { params: { 'response[put_return_resource]': true } }
    );
};

export default {
    updateUser,
    updateUserPrivilege,
    removeUserAvatar,
    deleteUserByPrivilegeId,
}